module.exports = __webpack_public_path__ + "img/portfolio-08-01-480x343.48cf3df1.jpg";